import { createApp } from '@app/adapters/create-app'
import InsightsRightDrawer from '@app/insights/components/sidebar/insights-right-drawer.vue'

window.onDomLoad(function ($dom) {
  const doc = $dom[0]
  const element = doc.querySelector<HTMLElement>(
    "[data-behaviour='insights/right-drawer']"
  )

  if (!element) return

  const app = createApp(InsightsRightDrawer, {})
  app.mount(element)
})
